import {ChangeDetectionStrategy, Component, computed, inject, input, OnInit, signal} from '@angular/core';
import {GetSelectDataParams, RecordData} from "../../../../../../../../core/types/records-table.types";
import {KeyTestsService} from "../../services/key-tests.service";
import {propertyLazySelectDataProduct} from "../../configs/key-tests-modal-config";

@Component({
  selector: 'app-key-test-header',
  imports: [],
  templateUrl: './key-test-header.component.html',
  styleUrl: './key-test-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KeyTestHeaderComponent implements OnInit {
  parentData = input.required<RecordData>();

  private keyTestsService: KeyTestsService = inject(KeyTestsService);

  public productName = signal<string>('');
  public article = computed(() => this.parentData()['article']);

  public async ngOnInit() {
    await this.fetchProductSelectData();
  }

  private async fetchProductSelectData() {
    const getSelectDataParams: GetSelectDataParams = {
      propertyLazySelect: propertyLazySelectDataProduct,
      id: Number(this.parentData()['productId'])
    };

    const selectData = await this.keyTestsService.fetchSelectData(getSelectDataParams).catch(() => []);
    this.productName.set(selectData.at(0)?.value || '');
  }
}
